import './level.css';
export default {
  "level": "pf-v6-l-level",
  "modifiers": {
    "gutter": "pf-m-gutter"
  }
};